/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : DisplayProductCardNONMSASO.tsx
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422337
*
* @Date         : Sep 28, 2020
*
* @Version      : Version 1.0
*
*
* By             : H422336
* On             : Oct 06,2020
* Description    : ASDS-3227 APU enhancements as part of phase-2
*
*****************************************************************************/

import * as React from 'react';
import { Grid, Icon, Card } from '@scuf/common';
import { DataTable } from '@scuf/datatable';
import '@scuf/common/honeywell/theme.css';
import './ConfigureAPU.css';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';

function unitPriceRenderer(cellData: ICellData) {
    return <span>{`$${cellData.value.toFixed(2)}`}</span>;
}

function NonMSAServiceOrderConfigSummary(props: any) {
    return (
        <Card className="fullwidthCard margin-top-0 config-confirmation-card-spacing">
            <Card.Content>
                <Grid>
                    <Grid.Row className="dispayProductCard">
                        <Grid.Column width={11} className="fullwidthRow">
                            <span className="ca-serial-title-text">Confirm Configuration</span>
                        </Grid.Column>
                        <Grid.Column width={1} className="fullwidthRow">
                            <div className="pull-right">
                            <Icon
                                root="common"
                                name="edit"
                                size="small"
                                className="confirmation-edit-icon"
                                onClick={props.gotoProductConfigureTab}
                            />
                                </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={12} className="ca-confirmConfigurationTab fullwidthRow">
                            <DataTable
                                data={props.productConfigData}
                                scrollable={true}
                                scrollHeight="150px"
                                virtualRowHeight={48}
                                resizableColumns={true}
                            >
                                <DataTable.Column field="serialNumber" header="APU Serial No" align="left" editable={false}/>
                                <DataTable.Column field="serviceOrderNumber" header="Service Order No" align="left" editable={false}/>
                                <DataTable.Column field="unitPrice" header="Unit Price" align="left" renderer={unitPriceRenderer} editable={false}/>
                            </DataTable>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Card.Content>
        </Card>
    );
}

export default NonMSAServiceOrderConfigSummary;
